/* FalcX shop all (r7, /pages/shop).
   Reads the vehicle on show from window.FalcxVehicle (falcx-finder.js; read only) and
   1. fills the "Parts for your BA–BF Ute" line, linking to that Falcon's hub with its body style;
   2. marks that generation's card in "Shop by your Falcon" and points it at the same address.
   "your" is said only of the remembered vehicle (FalcxVehicle.isMine), as everywhere else on the site.
   Re-runs on falcx:vehicle-change / falcx:browsing-change (the header's Change dialog, Clear vehicle).
   Without JS the line stays hidden and the cards are plain hub links. */
(function (root) {
  'use strict';
  function genOf(series) {
    if (series === 'ea-ed' || series === 'ef-el' || series === 'ea-el') return 'ea-el';
    if (series === 'fg' || series === 'fgx' || series === 'fg-fgx') return 'fg-fgx';
    return series || '';
  }
  function hrefFor(v) {
    if (!v || !v.url) return '';
    var base = String(v.url).split('#')[0].split('?')[0];
    return base + '?series=' + encodeURIComponent(v.series) + '&body=' + encodeURIComponent(v.body);
  }
  /* What the page should show for the vehicle on show (null = none). Pure, for tests. */
  function plan(active, mine) {
    if (!active || !active.label || !active.url) return null;
    return {
      gen: genOf(active.series),
      pre: mine ? 'Parts for your ' : 'Parts for ',
      name: active.label,
      kicker: mine ? 'mine' : 'showing',
      href: hrefFor(active),
      image: active.image || ''
    };
  }
  var api = {genOf: genOf, hrefFor: hrefFor, plan: plan};
  if (typeof module !== 'undefined' && module.exports) { module.exports = api; return; }
  if (!root.document) return;
  var doc = root.document;

  function setText(el, value) { if (el && el.textContent !== value) el.textContent = value; }
  function paint() {
    var fv = root.FalcxVehicle;
    var active = fv && fv.getActive ? fv.getActive() : null;
    var p = plan(active, !!(active && fv.isMine && fv.isMine(active)));
    doc.querySelectorAll('[data-shopall-lead]').forEach(function (lead) {
      if (!p) { lead.hidden = true; lead.dataset.state = 'none'; return; }
      var kicker = lead.querySelector('[data-shopall-lead-kicker]');
      if (kicker && kicker.dataset.mine === undefined) kicker.dataset.mine = kicker.textContent;
      setText(kicker, p.kicker === 'mine' ? (kicker.dataset.mine || 'Your Falcon') : 'Showing');
      setText(lead.querySelector('[data-shopall-lead-pre]'), p.pre);
      setText(lead.querySelector('[data-shopall-lead-name]'), p.name);
      var link = lead.querySelector('[data-shopall-lead-link]');
      if (link && link.getAttribute('href') !== p.href) link.setAttribute('href', p.href);
      var img = lead.querySelector('[data-shopall-lead-img]');
      if (img) {
        if (p.image) { if (img.getAttribute('src') !== p.image) img.setAttribute('src', p.image); img.hidden = false; }
        else img.hidden = true;
      }
      var change = lead.querySelector('[data-vehicle-change]');
      if (change) change.setAttribute('aria-label', 'Change vehicle, now ' + p.name);
      lead.dataset.state = p.kicker;
      lead.hidden = false;
    });
    doc.querySelectorAll('[data-shopall-gen]').forEach(function (card) {
      if (card.dataset.baseHref === undefined) card.dataset.baseHref = card.getAttribute('href') || '';
      var on = !!p && card.dataset.shopallGen === p.gen;
      var mark = card.querySelector('[data-shopall-mark]');
      card.classList.toggle('is-current', on);
      if (mark) { mark.hidden = !on; setText(mark, on ? (p.kicker === 'mine' ? 'Your Falcon' : 'Showing') : ''); }
      var href = on ? p.href : card.dataset.baseHref;
      if (href && card.getAttribute('href') !== href) card.setAttribute('href', href);
      /* The marked card shows the body style on show (ute, wagon) when the vehicle data has its render. */
      var img = card.querySelector('[data-shopall-car-img] img');
      if (img) {
        if (img.dataset.baseSrc === undefined) { img.dataset.baseSrc = img.getAttribute('src') || ''; img.dataset.baseSrcset = img.getAttribute('srcset') || ''; }
        if (on && p.image) {
          if (img.getAttribute('src') !== p.image) { img.removeAttribute('srcset'); img.setAttribute('src', p.image); }
        } else if (img.getAttribute('src') !== img.dataset.baseSrc) {
          img.setAttribute('src', img.dataset.baseSrc);
          if (img.dataset.baseSrcset) img.setAttribute('srcset', img.dataset.baseSrcset);
        }
      }
    });
  }
  doc.addEventListener('falcx:vehicle-change', paint);
  doc.addEventListener('falcx:browsing-change', paint);
  doc.addEventListener('shopify:section:load', paint);
  if (doc.readyState === 'loading') doc.addEventListener('DOMContentLoaded', paint); else paint();
})(typeof window !== 'undefined' ? window : this);
